import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useMemo, useState } from 'react';

import { Poll } from '../../db/polls/types';

interface PollContextType {
  poll: Poll | null;
  setPoll: Dispatch<SetStateAction<Poll | null>>;
}

const PollContext = createContext<PollContextType | undefined>(undefined);

export function usePollContext() {
  const context = useContext(PollContext);
  if (!context) {
    throw new Error('Using usePollContext outside PollContextProvider is not allowed.');
  }
  return context;
}

function usePollContextProviderVM() {
  const [poll, setPoll] = useState<Poll | null>(null);

  return useMemo(
    () => ({
      poll,
      setPoll,
    }),
    [poll]
  );
}

export interface PollContextProviderProps {
  children: ReactNode;
}

export function PollContextProvider({ children }: PollContextProviderProps) {
  const providerValue = usePollContextProviderVM();
  return <PollContext.Provider value={providerValue}>{children}</PollContext.Provider>;
}
